var React = require('react');

function CaretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.71902 0.295375L6.70631 5.28993C7.0979 5.68209 7.0979 6.31791 6.70631 6.71008L1.71902 11.7046C1.32576 12.0985 0.688188 12.0984 0.294945 11.7046C-0.0983094 11.3108 -0.0983203 10.6723 0.294945 10.2785L4.56719 6L0.294945 1.72153C-0.0983094 1.3277 -0.0983203 0.689213 0.294945 0.295375C0.688209 -0.0984637 1.32577 -0.0984528 1.71902 0.295375Z","fill":"#151414"}));
}

CaretInline.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none"};

module.exports = CaretInline;

CaretInline.default = CaretInline;
